import React, { Component } from "react";

import styles from "./FindEventsBanner.scss";

import SearchBar from "../../../components/search/searchBar/SearchBar";

class FindEventsBanner extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <h2 className={styles.heading}>Experience….and make an impact</h2>
          <SearchBar />
        </div>
      </div>
    );
  }
}

export default FindEventsBanner;
